<template>
  <Modal v-if="showQrCode" @close="$emit('closeModal')">
    <div class="openQRCode">
      <div class="openQRCode__header">
        <img
          class="openQRCode__header-img"
          src="@/assets/icons/CloseModal.svg"
          alt="Close Modal"
          @click="$emit('closeModal')"
        />
      </div>
      <form>
        <Input
          v-if="idActiveDelivery && showOnlyDeliveryId"
          type="text"
          :value="idActiveDelivery"
          :title="$t('kolliID')"
          disabled
        />
        <Input
          v-if="deliveryQRCode && showOnlyDeliveryQRCode"
          type="text"
          :value="deliveryQRCode.code"
          :title="$t('kolliID')"
          disabled
        />
        <Input
          v-if="pharmacyEntryPin && userBoxPin"
          type="text"
          :value="`2:${pharmacyEntryPin}:${userBoxPin}`"
          disabled
        />
      </form>
      <qrcode-vue
        v-if="idActiveDelivery && showOnlyDeliveryId"
        :value="idActiveDelivery"
        :size="300"
        level="H"
      />
      <qrcode-vue
        v-if="deliveryQRCode && showOnlyDeliveryQRCode"
        :value="deliveryQRCode.code"
        :size="300"
        level="H"
      />
      <qrcode-vue
        v-if="pharmacyEntryPin && userBoxPin"
        :value="`2:${pharmacyEntryPin}:${userBoxPin}`"
        :size="300"
        level="H"
      />
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import QrcodeVue from 'qrcode.vue';

@Options({
  name: 'OpenQRCode',
  props: [
    'showQrCode',
    'idActiveDelivery',
    'deliveryQRCode',
    'showOnlyDeliveryQRCode',
    'showOnlyDeliveryId',
    'pharmacyEntryPin',
    'userBoxPin'
  ],
  components: {
    QrcodeVue
  }
})
export default class OpenQRCode extends Vue {}
</script>

<style lang="scss" scoped>
.openQRCode {
  max-width: 300px;
  height: 100%;
  padding: 24px;
  .openQRCode__header {
    text-align: right;
    .openQRCode__header-img {
      cursor: pointer;
    }
  }
  form {
    margin: 20px 0;
  }
}
</style>
